module.exports = __webpack_public_path__ + "img/3.1fa2681f.png";